import { render, staticRenderFns } from "./ReusableDynamicModule.vue?vue&type=template&id=5fdec080"
import script from "./ReusableDynamicModule.vue?vue&type=script&lang=js"
export * from "./ReusableDynamicModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports